// extracted by mini-css-extract-plugin
module.exports = {"nav":"tutor_nav__mJImo","logo":"tutor_logo__3gvFJ","tutorList":"tutor_tutorList__1Ms8X","tutorDetails":"tutor_tutorDetails__3m4I1","footer":"tutor_footer__3mSJ2"};